// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"88a4783ca9d7cba80c12","303":"14309d05602154f89426","495":"efb05f837ced6be501ab"}[chunkId] + ".js";
};